import { render, staticRenderFns } from "./stakeholders.vue?vue&type=template&id=d25748b6&scoped=true"
import script from "./stakeholders.vue?vue&type=script&lang=js"
export * from "./stakeholders.vue?vue&type=script&lang=js"
import style0 from "./stakeholders.vue?vue&type=style&index=0&id=d25748b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25748b6",
  null
  
)

export default component.exports